import type { AppRouter } from "@bigpp/trpc";
import { QueryClient } from "@tanstack/react-query";
import { httpBatchLink, httpSubscriptionLink, splitLink } from "@trpc/client";
import { createTRPCReact } from "@trpc/react-query";
import superjson from "superjson";

import { env } from "./env.ts";

export const trpc = createTRPCReact<AppRouter>();

export const queryClient = new QueryClient();

const trpcUrl = `${env.VITE_WEB_URL}/api/trpc`;

export const trpcClient = trpc.createClient({
  links: [
    splitLink({
      condition: (op) => op.type === "subscription",
      true: httpSubscriptionLink({
        url: trpcUrl,
        transformer: superjson,
        // Standard EventSource supports cookies only via withCredentials.
        eventSourceOptions: { withCredentials: true },
      }),
      false: httpBatchLink({
        url: trpcUrl,
        transformer: superjson,
        fetch: (url, init) =>
          fetch(url, {
            ...init,
            credentials: "include",
          }),
      }),
    }),
  ],
});
